module.exports = __webpack_public_path__ + "img/16.2e6827ef.jpg";